module.exports = __webpack_public_path__ + "static/media/61db6375-77fd-40c8-86e1-208a4d640c87.d4096892.JPG";